import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    Button,
    IconButton,
    InputAdornment,
    MenuItem,
    TextField,
    Stack,
    Typography,
    Box,
    Grid,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";


export default function TreePicker({ value = [], onChange }) {
    const { t } = useTranslation();
    const TREE_OPTIONS = [
        { label: t("tree_picker.unknown"), code: "unknown" },
        { label: t("tree_picker.priede"), code: "priede" },
        { label: t("tree_picker.egle"), code: "egle" },
        { label: t("tree_picker.berzs"), code: "berzs" },
        { label: t("tree_picker.apse"), code: "apse" },
        { label: t("tree_picker.malksnis"), code: "malksnis" },
        { label: t("tree_picker.balksnis"), code: "balksnis" },
        { label: t("tree_picker.ozols"), code: "ozols" },
        { label: t("tree_picker.osis"), code: "osis" },
        { label: t("tree_picker.liepa"), code: "liepa" },
        { label: t("tree_picker.bligzna"), code: "bligzna" },
        { label: t("tree_picker.klava"), code: "klava" },
        { label: t("tree_picker.sauskegle"), code: "sauskegle" },
        { label: t("tree_picker.sauskpriede"), code: "sauskpriede" },
        { label: t("tree_picker.other"), code: "other" },
    ];

    const handleAdd = () => {
        onChange([...value, { code: "", percentage: "" }]);
    };

    useEffect(() => {
        if (value.length === 0) {
            onChange([{ code: "", percentage: "" }]);
        }
    }, [value, onChange]);

    const handleRemove = (index) => {
        const newList = [...value];
        newList.splice(index, 1);
        onChange(newList);
    };

    const handleChange = (index, field, fieldValue) => {
        const newList = [...value];
        newList[index][field] = field === "percentage" ? Number(fieldValue) : fieldValue;
        onChange(newList);
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Stack spacing={2} sx={{ width: "100%" }}>
                {value.map((tree, index) => (
                    <Grid container alignItems="center">
                        <Grid item xs={12} md={7}>
                            <Box mr={2}>
                                <TextField
                                    fullWidth
                                    select
                                    size="small"
                                    label={t("tree_picker.tree_type")}
                                    value={tree.code}
                                    onChange={(e) => handleChange(index, "code", e.target.value)}
                                >
                                    {TREE_OPTIONS.map((option) => (
                                        <MenuItem key={option.code} value={option.code}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Box mr={2}>
                                <TextField
                                    fullWidth
                                    label={t("tree_picker.percentage")}
                                    type="number"
                                    size="small"
                                    value={tree.percentage}
                                    onChange={(e) => handleChange(index, "percentage", e.target.value)}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                        inputProps: { min: 0, step: 0.1 }
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={1}>
                            <IconButton color="error" onClick={() => handleRemove(index)}>
                                <Delete />
                            </IconButton>
                        </Grid>
                    </Grid>

                ))}

                <Button
                    variant="outlined"
                    startIcon={<Add />}
                    onClick={handleAdd}
                    sx={{ alignSelf: "start", mt: 1 }}
                >
                    {t("tree_picker.add_type")}
                </Button>
            </Stack>
        </Box>
    );
}
